import { RefObject, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

// selectorOrRef can either be a querySelector or React ref
// eg '#site-navigation' or const ref = useRef(null)
const useSticky = (selectorOrRef: string | RefObject<HTMLDivElement | null>) => {
  const [isSticky, setIsSticky] = useState(false);
  const [intersectionRatio, setIntersectionRatio] = useState();
  const isSelector = typeof selectorOrRef === 'string';
  let elementToObserve;
  if (typeof window !== 'undefined' && isSelector) {
    elementToObserve = window.document.querySelector(selectorOrRef as string);
  }

  const toggleSticky = observedElements => {
    const observedElement = observedElements[0];
    if (observedElement.intersectionRatio === 0) {
      setIsSticky(true);
    } else if (observedElement.intersectionRatio === 1) {
      setIsSticky(false);
    }
    setIntersectionRatio(observedElement.intersectionRatio);
  };

  useEffect(() => {
    if (elementToObserve === null) return;

    const observer = new IntersectionObserver(debounce(toggleSticky, 250), {
      threshold: [0, 0.25, 0.5, 0.75, 1],
    });
    if (isSelector) {
      observer.observe(elementToObserve);
    } else {
      elementToObserve = (selectorOrRef as RefObject<null>).current;
      observer.observe(elementToObserve);
    }
  }, [elementToObserve]);

  return {
    isSticky,
    intersectionRatio,
  };
};

export default useSticky;
